import { EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { Ok, Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';
import { KameleoonData } from 'src/kameleoonData/types';

export class TargetPersonalizationCondition implements ICondition {
  private personalizationId?: number | null;

  constructor({ personalizationId }: ConditionDataType) {
    this.personalizationId = personalizationId;
  }

  public evaluate(data: EvaluationDataType): Result<boolean, KameleoonError> {
    if (!data.targetingData) {
      return Ok(false);
    }

    return Ok(this.checkCondition(data));
  }

  private checkCondition(data: EvaluationDataType): boolean {
    if (!this.personalizationId) {
      return false;
    }
    const personalizationData =
      data.targetingData?.[KameleoonData.Personalization];
    return personalizationData?.[this.personalizationId] !== undefined;
  }
}
